<div class="p-3">
  <div class="row">
    <div
      *bitfUiRoleManager="{ action: eRoleActions.EDIT_ITEM }"
      class="col-24 col-sm-12 border-right fixed-full-available-height-screen"
    >
      <mpa-file-uploader
        (startUpload)="onUpload()"
        [fileUploaderConfig]="{ extensions: ['jpg', 'jpeg', 'png'], concatenateMultipleFiles: true }"
      >
      </mpa-file-uploader>
    </div>

    <div
      [ngClass]="uiRoleManagerService.canI(eRoleActions.EDIT_ITEM) ? 'col-24 col-sm-12' : 'col'"
      class="mt-4 mt-sm-0"
    >
      @if (selectedItem?.images?.length) {
        <h4>{{ 'COMMON.LABEL.IMAGES' | translate }}</h4>
        <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="images-drop-list">
          @for (image of imagesList; track trackByImageId(i, image); let i = $index) {
            <div
              class="item-container border-bottom d-flex justify-content-between py-2 w-100 cursor-move"
              cdkDrag
            >
              <div class="item-details d-flex align-items-center flex-shrink-1">
                <div class="drag-handle mr-2 d-flex align-items-center">
                  <mat-icon class="text-muted">drag_indicator</mat-icon>
                </div>
                <div
                  class="item-image rounded d-flex flex-shrink-0 align-items-center justify-content-center mr-3 cursor-zoom-in"
                  role="button"
                  [attr.aria-label]="'ITEM.DETAIL.ZOOM_IN' | translate"
                  (click)="onOpenImageZoom(i, $event)"
                >
                  <img
                    [src]="$safeNavigationMigration(image?.getImageByFormat('xsmall')?.url)"
                    [alt]="image.name"
                  />
                </div>
                <div class="item-name">
                  {{ image.name }}
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-end">
                <button
                  mat-icon-button
                  color="primary"
                  [matTooltip]="
                    (image.caption.hiddenOnPrint
                      ? 'ITEM.DETAIL.IMAGE_HIDDEN_ON_PRINT'
                      : 'ITEM.DETAIL.IMAGE_VISIBLE_ON_PRINT'
                    ) | translate
                  "
                  (click)="onChangeImageVisibilityOnPrint(image)"
                >
                  <mat-icon>{{ image.caption.hiddenOnPrint ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <button mat-icon-button color="primary" (click)="onDownloadImage(image)">
                  <mat-icon>download</mat-icon>
                </button>
                @if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM)) {
                  <button mat-icon-button color="primary" (click)="onRemoveImage(image)">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (!selectedItem?.images?.length) {
        <h4>{{ 'ITEM.DETAIL.EMPTY_ITEM_IMAGES' | translate }}</h4>
      }
    </div>
  </div>
</div>
